module.exports = __webpack_public_path__ + "static/media/ear-and-mastoid-process-diseases-icon.6acf929e.svg";